<div class="a-ac-container">
    <div class="a-ac-input-wrapper" [ngClass]="{'a-ac-disabled':disabled}">
        <input type="text" #input (blur)="inputBlur($event)" [disabled]="disabled" (focus)="inputFocus($event)"
            (keydown.ArrowUp)="upKeyDown($event)" (keydown.ArrowDown)="downKeyDown($event)"
            (keydown.enter)="enterKeyDown($event)" (keyup)="inputKeyup($event)" [(ngModel)]="filterValue">
    </div>
    <ul class="a-ac-filtered-list" *ngIf="showPopup" [style.width]="popupWidth" [style.height]="popupHeiht">
        <li *ngFor="let item of getFilteredItems()" (click)="selectByClick(item)"
            [ngClass]="{'a-ac-filtered_active':_tempSelectedItem==item}">
            {{item.text}}
        </li>
        <li class="a-ac-filtered-empty" *ngIf="getFilteredItems().length===0">No Data Found.</li>
    </ul>
</div>